import { render, staticRenderFns } from "./EgiftOrder.vue?vue&type=template&id=1a5f84de&scoped=true"
import script from "./EgiftOrder.vue?vue&type=script&lang=js"
export * from "./EgiftOrder.vue?vue&type=script&lang=js"
import style0 from "./EgiftOrder.vue?vue&type=style&index=0&id=1a5f84de&prod&lang=scss"
import style1 from "./EgiftOrder.vue?vue&type=style&index=1&id=1a5f84de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f84de",
  null
  
)

export default component.exports